import React from "react";
import { sunbScribeOnClick, unsubscribe } from "../../../services/globalEventHandler";
import "./dropdownBlock.css";


interface dropdownBlockProps {
    title: string | JSX.Element,
    isRightPosition?: boolean,
    children: JSX.Element[] | JSX.Element
}
 
interface dropdownBlockState {
    isShowHiddenDropdown: boolean,
}
 
class DropdownBlock extends React.Component<dropdownBlockProps, dropdownBlockState> {
    constructor(props:dropdownBlockProps){
        super(props);
        this.state = {
            isShowHiddenDropdown: false,
        }
    }

    uniqId = "";

    componentDidMount(){
        this.uniqId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
        sunbScribeOnClick(this.hideModal, this.uniqId);
    }

    componentWillUnmount(){
        unsubscribe(this.uniqId);
    }

    modalBackground = "dropdown-block-layout";
    hideModal = () =>  this.setState({ isShowHiddenDropdown: false});

    toggleDropdownHiddenBlock = (event: React.MouseEvent<Element, MouseEvent>) => {
        event.stopPropagation();
        this.setState({ isShowHiddenDropdown: !this.state.isShowHiddenDropdown})
    }

    toggleDropdownHiddenBlock2 = (event: React.MouseEvent<Element, MouseEvent>) => {
        event.stopPropagation();
    }

    render() { 
        return (
                <div className={`dropdown-block ${this.state.isShowHiddenDropdown ? "show-drop" : ""}`} onClick={this.toggleDropdownHiddenBlock2} >
                    {typeof this.props.title === 'string' ? <span className="dropdown-title" onClick={this.toggleDropdownHiddenBlock}>
                        {this.props.title}
                    </span> :
                    <span onClick={this.toggleDropdownHiddenBlock}>
                        {this.props.title}
                    </span>
                    }
                    <div className={`dropdown-hidden-block ${this.props.isRightPosition && 'right'}`}>
                        {this.props.children}
                    </div>
                </div>
        );
    }
}
 
export default DropdownBlock;